import axiosInstance, { getBaseUrl } from '../Config/AxiosInstance';

const PREFIX = `/clinic/job`;

export const downloadAudio = jobId => {
  return axiosInstance.get(PREFIX + `/${jobId}/audio-url`);
};

export const getDemographics = jobId => {
  return axiosInstance.get(PREFIX + `/${jobId}/demographics`);
};
export const getJobInfoForPrint = jobId => {
  return axiosInstance.get(PREFIX + `/info-to-print?jobId=${jobId}`);
};
export const sectionFetch = jobId => {
  return axiosInstance.get(PREFIX + `/${jobId}/sections`);
};
// Returns generated attachment files for a job, e.g. [{ fileLink, noteType, ... }]
export const getJobAttachments = jobId => {
  return axiosInstance.get(PREFIX + `/attachments?jobId=${jobId}`);
};

export const getHeadings = jobId => {
  return axiosInstance.get(PREFIX + `/${jobId}/section-headings`);
};

export const editSection = (jobId, data, sessionId) => {
  return axiosInstance.put(
    PREFIX + `/${jobId}/sections?session-id=${sessionId}`,
    data
  );
};
export const billJob = (jobId, sessionId) => {
  return axiosInstance.put(PREFIX + `/${jobId}/bill?sessionId=${sessionId}`);
};

export const deleteSection = (jobId, sectionId) => {
  return axiosInstance.delete(PREFIX + `/${jobId}/sections/${sectionId}`);
};
export const deleteJob = (jobId, sectionId) => {
  return axiosInstance.put(
    PREFIX + `/delete?jobId=${jobId}&sessionId=${sectionId}`
  );
};
export const getInference = (jobId, sectionId, newInferenceActive) => {
  if (!newInferenceActive) {
    newInferenceActive = false;
  }
  return axiosInstance.get(
    PREFIX +
      `/${jobId}/inference/${sectionId}?enable-new-inference=${newInferenceActive}`
  );
};

export const getPatientDataSelection = jobId => {
  return axiosInstance.get(PREFIX + `/patient-data-selection?jobId=${jobId}`);
};

export const updatePatientDataSelection = (jobId, data) => {
  return axiosInstance.post(
    PREFIX + `/patient-data-selection?jobId=${jobId}`,
    data
  );
};

export const forceUpdateJobInference = jobId => {
  return axiosInstance.post(PREFIX + `/resetJob?job-id=${jobId}`);
};

export const updateAudioTime = (jobId, audioTime) => {
  return axiosInstance.put(
    PREFIX + `/${jobId}/audio-time?audioTime=${audioTime}`
  );
};

export const updateInference = (jobId, sectionId, data) => {
  return axiosInstance.put(PREFIX + `/${jobId}/inference/${sectionId}`, data);
};

export const updateInferenceEditFlag = (jobId, sectionId, data) => {
  return axiosInstance.put(
    PREFIX + `/${jobId}/inference/${sectionId}/allow-overwrite`,
    data
  );
};

export const getIncompleteJobs = (
  facilities,
  page,
  size,
  sortKey,
  sortOrder,
  searchKey,
  updateCode
) => {
  let url =
    PREFIX +
    `/in-complete?page=${page}&size=${size}&sortOrder=${sortOrder}&sortKey=${sortKey}&searchValue=${searchKey}`;
  if (updateCode) {
    url = url + `&jobUpdateCode=${updateCode}`;
  }
  return axiosInstance.get(url);
};

export const retryIncompleteJobSubmission = (jobIds, sessionId) => {
  return axiosInstance.post(
    PREFIX + `/retry?job-ids=${jobIds}&session-id=${sessionId}`
  );
};

export const reconvertJob = jobIds => {
  return axiosInstance.post(PREFIX + `/reconvertJob?job-id=${jobIds}`);
};

export const releaseJob = jobId => {
  return axiosInstance.put(PREFIX + `/${jobId}/releaseJob`);
};

export const GetAdminJobCount = () => {
  return axiosInstance.get(PREFIX + `/job-board`);
};
export const GetWorkType = jobId => {
  return axiosInstance.get(PREFIX + `/${jobId}/work-types`);
};
export const updateWorkType = (jobId, sessionId, workType) => {
  const encoded = encodeURIComponent(workType);
  return axiosInstance.put(
    PREFIX +
      `/${jobId}/work-types?sessionId=${sessionId}&workType=${encoded}&jobId=${jobId}`
  );
};
// export const updateWorkType = (jobId, sessionId, workType) => {
//   return axiosInstance.put(
//     PREFIX +
//       `/${jobId}/work-types?sessionId=${sessionId}&workType=${workType}&jobId=${jobId}`
//   );
// };
export const GetJobCount = () => {
  return axiosInstance.get(PREFIX + `/count/my-jobs`);
};
export const GetJobToRevieCount = () => {
  return axiosInstance.get(PREFIX + `/count/jobs-to-review`);
};

export const releaseSection = (jobId, sessionId) => {
  return axiosInstance.put(
    PREFIX + `/release-incomplete-jobs?session-id=${sessionId}`,
    jobId
  );
};
export const updateDate = (jobId, date) => {
  return axiosInstance.put(
    PREFIX + `/${jobId}/appointment-date?encounterDate=${date}`
  );
};

export const getJobsByFacility = (facilityId, jobStatusList) => {
  let queryPart = '';
  jobStatusList.forEach(status => {
    queryPart += `&jobStatus=${status}`;
  });
  return axiosInstance.get(
    PREFIX + `/facility-based-jobs?facilityId=${facilityId}` + queryPart
  );
};
// export const strikeDate = jobId => {
//   return axiosInstance.patch(PREFIX + `/${jobId}/strike`);
// };
export const strikeDate = (jobId, sessionId) => {
  return axiosInstance.patch(
    PREFIX + `/${jobId}/strike?sessionId=${sessionId}`
  );
};

const getConversionalApiUrl = () => {
  const apiServer = getBaseUrl();
  if (apiServer?.includes('stage-api')) {
    return 'https://stage-conversional-api.cascade.md';
  } else if (apiServer?.includes('dev-api')) {
    return 'https://dev-conversional-api.cascade.md';
  } else {
    return 'https://conversional-api.cascade.md';
  }
};

export const generateAiContent = (jobId, heading, messages) => {
  return axiosInstance.post('/clinic/ai/generate-job-section', { jobId, heading, messages });
};

export const generateAiContentWithFile = (messages, file) => {
  const formData = new FormData();
  formData.append('messages', JSON.stringify(messages));
  formData.append('file', file);
  return axiosInstance.post(getConversionalApiUrl() + '/rpa/prompt', formData);
};

export const generateMipsScore = (userPrompt, jobSections) => {
  return axiosInstance.post(getConversionalApiUrl() + '/rpa/prompt/mips-score', {
    userPrompt,
    jobSections
  });
};

export const saveAiJobSectionGeneration = (jobId, request, response) => {
  return axiosInstance.post(`/clinic/ai/job-section-generation`, {
    jobId,
    request,
    response
  });
};

export const acknowledgeAiGeneration = (jobId, sessionId) => {
  return axiosInstance.post(
    `/clinic/ai/acknowledge?jobId=${jobId}&sessionId=${sessionId}`
  );
};

export const getAiJobSectionContent = jobId => {
  return axiosInstance.get(`/clinic/ai/job-section-content?jobId=${jobId}`);
};

export const markAiSectionAsAdded = (jobId, heading) => {
  return axiosInstance.put(
    `/clinic/ai/job-section-content/added?jobId=${jobId}&heading=${encodeURIComponent(heading)}`
  );
};

export const saveMipsScore = data => {
  return axiosInstance.post('/clinic/ai/mips-score', data);
};
